import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'App',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M6.6 14.2h1.5l.2 1.8h1.3L8.2 8H6.5L5 16h1.3l.3-1.8zm.7-4.6l.6 3.4H6.8l.5-3.4zm4.5 3.1h.6c1.7 0 2.5-.7 2.5-2.4S14.2 8 12.4 8h-2v8h1.4v-3.3zm0-3.6h.5c.9 0 1.2.3 1.2 1.2s-.3 1.2-1.2 1.2h-.5V9.1zm5.6 3.6h.6c1.7 0 2.5-.7 2.5-2.4S19.7 8 18 8h-2v8h1.4v-3.3zm0-3.6h.5c.9 0 1.2.3 1.2 1.2s-.3 1.2-1.2 1.2h-.5V9.1zM22 5H2C.9 5 0 5.9 0 7v10c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM2 13c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm19.5 5H4V6h17.5v12zm1.5-3.5c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-5c0-.1.1-.2.2-.2s.2.1.2.2v5z" }
      })]
    );
  }
};